import { useEffect, useRef, useState } from "react";
import { playUrl, stopAudio, getPlayer } from "@/lib/sharedAudio";
import { Play, Square, Wind } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let owner = null;

// A recorded Reset the Coach plays for him inside the chat — starts by itself, free to play.
export default function CoachPlayCard({ play, autoPlay = true, onFinished }) {
  const [on, setOn] = useState(false);
  const me = useRef(Math.random());
  const full = `${BACKEND_URL}${play.url}`;
  const start = () => { owner = me.current; setOn(true); playUrl(full, { onEnded: () => { setOn(false); onFinished?.(); } }).catch(() => {}); };
  const stop = () => { stopAudio(); setOn(false); };
  useEffect(() => {
    if (autoPlay) start();
    return () => { if (getPlayer().src === full) stopAudio(); };
  }, [play.url]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { // mirror the shared player — another card or voice taking over turns this one off
    const p = getPlayer();
    const sync = () => setOn(owner === me.current && p.src === full && !p.paused && !p.ended);
    const evs = ["play", "pause", "ended", "emptied"];
    evs.forEach((ev) => p.addEventListener(ev, sync));
    return () => evs.forEach((ev) => p.removeEventListener(ev, sync));
  }, [full]);
  return (
    <button onClick={on ? stop : start} data-testid={`coach-play-${play.id}`}
      className="mt-3 w-full flex items-center gap-3 rounded-xl border border-primary/30 bg-primary/[0.06] px-3 py-2.5 text-left hover:bg-primary/[0.1] transition-colors">
      <span className="w-9 h-9 rounded-full bg-primary/15 flex items-center justify-center shrink-0">{on ? <Square className="w-4 h-4 text-primary" /> : <Play className="w-4 h-4 text-primary" />}</span>
      <span className="min-w-0">
        <span className="block text-[10px] uppercase tracking-[0.2em] text-primary flex items-center gap-1"><Wind className="w-3 h-3" /> Reset</span>
        <span className="block text-sm truncate">{play.title}</span>
      </span>
      <span className="ml-auto text-xs text-muted-foreground">{on ? "Playing" : "Play"}</span>
    </button>
  );
}
